import { useContext } from "react";
import { TranslationPrefixContext } from "./TranslationPrefix";
export const message = (id) => {
    const prefix = useContext(TranslationPrefixContext);
    let message = "";
    if (prefix !== null) {
        message += prefix;
    }
    if (message !== "" && !message.endsWith(".")) {
        message += ".";
    }
    message += id;
    return message;
};
//# sourceMappingURL=Message.js.map